declare global {
  interface Window {
    $crisp: any[];
    CRISP_WEBSITE_ID: string;
    hideCrisp: () => void;
    showCrisp: () => void;
  }
}

export function initCrispChat() {
  window.$crisp = [];
  window.CRISP_WEBSITE_ID = process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID || "";

  (() => {
    var d = document;
    var s = d.createElement("script");
    s.src = "https://client.crisp.chat/l.js";
    // @ts-expect-error
    s.async = 1;
    d.getElementsByTagName("head")[0].appendChild(s);
  })();

  window.$crisp.push(["safe", true]);
}

export function showCrispChat() {
  if (window.$crisp) {
    window.$crisp.push(["do", "chat:show"]);
  }
}

export function hideCrispChat() {
  if (window.$crisp) {
    window.$crisp.push(["do", "chat:hide"]);
  }
}
